<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedAssociationStatus"
      multi-select
      searchable
      :label="$t('Commitment')"
      :list="associationOptions"
      :placeholder="$t('Level of commitment expected')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { associationOptions } from '@/components/Job/constants'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedAssociationStatus: ModelRef<string[]> = defineModel({
  default: () => [],
})
</script>
